//文字コードはutf-8

import { initHamburgerMenu } from './modules/hamburger.js';
import { initHeader } from './modules/header.js';
import { initTiltCard } from './modules/tiltCard.js';
import { initCursorFollow } from './modules/cursorFollow.js';
import { initEntryAnimation } from './modules/entryAnimation.js';
import { initSpListScroll } from './modules/spListScroll.js';
import { initFilter } from './modules/filter.js';
import { initScrollTypingAnimation } from './modules/typingAnimation.js';
import { initFAQ } from './modules/faq.js';
import { initXjstorageConfig } from './modules/xjstorageConfig.js';
import { initIrNews } from './modules/irNews.js';
import { initIrList } from './modules/irList.js';
import { initSmoothScroll } from './modules/smoothScroll.js';
import { initModal } from './modules/modal.js';
import { initIrMovie } from './modules/irMovie.js';
import { initIrTop } from './modules/irTop.js';
import { initUmininDex } from './modules/umininDex.js';

initSmoothScroll();
initEntryAnimation();
initHamburgerMenu();
initHeader();
initTiltCard();
initCursorFollow();
initSpListScroll();
initFilter();
initScrollTypingAnimation();
initFAQ();
initXjstorageConfig();
initIrNews();
initIrList();
initModal();
initIrMovie();
initIrTop();
initUmininDex();

// Service IP KV: trigger background zoom on page load
const serviceIpKv = document.querySelector('.jsServiceIpKv');
if (serviceIpKv) {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            serviceIpKv.classList.add('is-bg-zoom');
        });
    });
}
